import { modalClickToCall } from '@v4/common/components/mixins/modal-service';
import { getQueryParams } from '@v4/common/utils/url';
import { sendClickToCallData, CLICK_TO_CALL_EVENTS } from '@v4/services/api/click-to-call/click-to-call';

const clickToCallModalHandler = {
    mixins: [modalClickToCall],
    data() {
        return {
            clickSource: null,
            clickToCallTimer: null,
        };
    },
    computed: {
        showImmediately() {
            return !!getQueryParams().show_popup;
        },
        pageId() {
            return this.fetchedData.id;
        },
        isVersionPage() {
            return this.pageId === 'version';
        },
        isLandingPage() {
            return this.formId && (this.formId === 'dkpromo' || this.formId === 'offer-landing-page');
        },
        isVDP() {
            return this.pageId === 'submodel';
        },
    },
    methods: {
        showClickToCallPopup() {
            if (this.showImmediately) {
                this.handleClickToCallModal();
            } else {
                this.clickToCallTimer = setTimeout(() => {
                    this.handleClickToCallModal();
                }, 7000);
            }
        },
        handleClickToCallModal(clickToCallData = null) {
            const hasFetchedData = this.fetchedData && this.fetchedData.clickToCallPopup;
            if (!(hasFetchedData || clickToCallData)) {
                return;
            }

            const data = hasFetchedData ? this.fetchedData.clickToCallPopup : clickToCallData;

            const { title, message, phoneNumber, cta, backButton } = data;

            if (!title || !message || !phoneNumber || !cta || !backButton) {
                return;
            }

            const ctcClickData = (clickToCallData && clickToCallData.ctcClickData) || null;

            const props = {
                title,
                message,
                phoneNumber,
                cta,
                backButton,
                trackClickEvent: () => this.trackClickToCallClick(CLICK_TO_CALL_EVENTS.default, ctcClickData),
            };

            this.clickSource = 'POPUP';
            this.clearClickToCallTimer();
            this.openClickToCallModal(props);
        },
        trackClickToCallClick(typeClick = CLICK_TO_CALL_EVENTS.default, ctcClickData = null) {
            let make, submodelName, projectId, submodelId;

            if (ctcClickData) {
                make = ctcClickData.make;
                submodelName = ctcClickData.submodelName;
                projectId = ctcClickData.projectId;
                submodelId = ctcClickData.submodelId;
            } else {
                const { formData, makeName, submodelCommercialName } = this.fetchedData;
                make = this.isLandingPage ? formData.submodel.makeName : makeName;
                submodelName = this.isLandingPage ? formData.submodel.submodelCommercialName : submodelCommercialName;
                projectId = Number(formData.project_id);
                submodelId = this.isVersionPage ? formData.version.submodelId : formData.submodel.submodelId;
            }

            const requestBody = {
                make,
                submodelName,
                projectId,
                submodelId,
                typeClick,
                ...(this.isVDP ? { clickToCallType: this.clickSource } : {}),
            };

            sendClickToCallData(requestBody);
        },
        clearClickToCallTimer() {
            if (this.clickToCallTimer) {
                clearTimeout(this.clickToCallTimer);
                this.clickToCallTimer = null;
            }
        },
    },
};

export default clickToCallModalHandler;
